import { NgFilter } from "@app/di/decorators";
import { Token } from "@app/di/token";

@NgFilter({
    token: Token.KbDateTimeFilter,
    dependencies: [
    ]
})
export class KbDateTimeFilter {
    constructor() {
        return ((d: Date) => {
            return d.getFullYear().toString() + "/" +
                (d.getMonth() + 1).toString() + "/" +
                d.getDate().toString() + " " +
                d.getHours() + ":" +
                d.getMinutes();
        }) as any;
    }
}
